import * as Types from './@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGoGoLiveParentGuideLocaleMutationVariables = Types.Exact<{
  goGoLiveParentGuideLocaleId: Types.Scalars['Int']['input'];
  introduction?: Types.InputMaybe<Types.Scalars['String']['input']>;
  learningGoals?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  showAndTell?: Types.InputMaybe<Types.Scalars['String']['input']>;
  user: Types.Scalars['String']['input'];
}>;


export type UpdateGoGoLiveParentGuideLocaleMutation = { __typename?: 'Mutation', updateGoGoLiveParentGuideLocale: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const UpdateGoGoLiveParentGuideLocaleDocument = gql`
    mutation UpdateGoGoLiveParentGuideLocale($goGoLiveParentGuideLocaleId: Int!, $introduction: String, $learningGoals: [String!], $showAndTell: String, $user: String!) {
  updateGoGoLiveParentGuideLocale(
    request: {goGoLiveParentGuideLocaleId: $goGoLiveParentGuideLocaleId, introduction: $introduction, learningGoals: $learningGoals, showAndTell: $showAndTell, user: $user}
  ) {
    count
    error
  }
}
    `;
export type UpdateGoGoLiveParentGuideLocaleMutationFn = Apollo.MutationFunction<UpdateGoGoLiveParentGuideLocaleMutation, UpdateGoGoLiveParentGuideLocaleMutationVariables>;

/**
 * __useUpdateGoGoLiveParentGuideLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateGoGoLiveParentGuideLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoGoLiveParentGuideLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoGoLiveParentGuideLocaleMutation, { data, loading, error }] = useUpdateGoGoLiveParentGuideLocaleMutation({
 *   variables: {
 *      goGoLiveParentGuideLocaleId: // value for 'goGoLiveParentGuideLocaleId'
 *      introduction: // value for 'introduction'
 *      learningGoals: // value for 'learningGoals'
 *      showAndTell: // value for 'showAndTell'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateGoGoLiveParentGuideLocaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGoGoLiveParentGuideLocaleMutation, UpdateGoGoLiveParentGuideLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGoGoLiveParentGuideLocaleMutation, UpdateGoGoLiveParentGuideLocaleMutationVariables>(UpdateGoGoLiveParentGuideLocaleDocument, options);
      }
export type UpdateGoGoLiveParentGuideLocaleMutationHookResult = ReturnType<typeof useUpdateGoGoLiveParentGuideLocaleMutation>;
export type UpdateGoGoLiveParentGuideLocaleMutationResult = Apollo.MutationResult<UpdateGoGoLiveParentGuideLocaleMutation>;
export type UpdateGoGoLiveParentGuideLocaleMutationOptions = Apollo.BaseMutationOptions<UpdateGoGoLiveParentGuideLocaleMutation, UpdateGoGoLiveParentGuideLocaleMutationVariables>;